import { useState } from "react";
import { Box, Menu, MenuItem, Typography } from "@mui/material";
import KeyboardArrowUpRoundedIcon from "@mui/icons-material/KeyboardArrowUpRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { useTranslation } from "react-i18next";
import { LanguageOptions } from "../../utils";
import { useStyles } from "./style";
import LanguageGroupIcon from "./languageGroupIcon";

export const LanguageSwitcher = ({ className = "", iconOnly = false }) => {
  const { i18n } = useTranslation();
  const classes = useStyles({ iconOnly });
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);

  const currentLanguage =
    LanguageOptions.find((option) => option.value === i18n.language) ??
    LanguageOptions[0];

  const handleSelect = (option) => {
    localStorage.setItem("i18nextLng", option.value);
    i18n.changeLanguage(option.value);
    setAnchorEl(null);
  };

  return (
    <>
      <Box
        className={`${classes.trigger_box} ${className}`}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <LanguageGroupIcon />
        {!iconOnly && (
          <Typography className={classes.trigger_text}>
            {currentLanguage.label}
          </Typography>
        )}
        {isOpen ? (
          <KeyboardArrowUpRoundedIcon
            fontSize="medium"
            sx={{ color: "#888E9E", ml: "-6px" }}
          />
        ) : (
          <KeyboardArrowDownRoundedIcon
            fontSize="medium"
            sx={{ color: "#888E9E", ml: "-6px" }}
          />
        )}
      </Box>
      <Menu
        className={classes.menu}
        anchorEl={anchorEl}
        open={isOpen}
        onClose={() => setAnchorEl(null)}
        elevation={0}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {LanguageOptions.map((option) => (
          <MenuItem
            key={option.value}
            onClick={() => handleSelect(option)}
            className={
              option.value === i18n.language
                ? classes.selected_item
                : classes.unselected_item
            }
          >
            <Typography
              className={
                option.value === i18n.language
                  ? classes.selected_item_text
                  : classes.unselected_item_text
              }
            >
              {option.label}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
